/**
 *
 */
(function () {
  'use strict';
  angular.module('cbl.telepass.wa').factory('TlpsMessaggiFctr', [
    'CblMessageSrvc',
    'TlpsLabelSrvc',
    'TlpsLoggerSrvc',
    function (messaggiSrvc, labelSrvc, loggerSrvc) {
      var processaResponse = function (response) {
        if (response.length > 0) {
          var respError;
          for (var index in response) {
            respError = this.processaResponse(response[index]);
            if (respError) {
              return true;
            }
          }
          return false;
        }

        if (
          response.data.errors &&
          response.data.errors.length === 0 &&
          (response.data.result === null || response.data.result === undefined)
        ) {
          var message = {
            message: 'Nessuna risposta ricevuta dal servizio'
          };
          messaggiSrvc.pushErrorMessage(message.message);
          return true;
        }
        var hasError = false;

        if (response.data && response.data.errors) {
          if (response.data.errors.length > 0) {
            for (var i in response.data.errors) {
              messaggiSrvc.pushErrorMessage(response.data.errors[i].message);
              console.error(response.data.errors[i].message);
            }
            hasError = response.data.errors.length > 0;
          }
          if (response.data.warnings.length > 0) {
            for (var k in response.data.warnings) {
              messaggiSrvc.pushWarningMessage(response.data.warnings[k].message);
            }
          }
          if (response.data.info.length > 0) {
            for (var z in response.data.info) {
              messaggiSrvc.pushInfoMessage(response.data.info[z].message);
            }
          }
        }
        if (response.status === 504) {
          messaggiSrvc.pushErrorMessage(labelSrvc.getLabel('errors.gatewaytimeout'));
          return true;
        }
        if (response.status === 400) {
          messaggiSrvc.pushErrorMessage(response.data.messageList.messages[0].message);
        }
        return hasError;
      };

      var addMessage = function (message) {
        if (message.type === 'E' || message.type === 'F') {
          messaggiSrvc.pushErrorMessage(message.message);
        } else if (message.type === 'W') {
          messaggiSrvc.pushWarningMessage(message.message);
        } else {
          messaggiSrvc.pushInfoMessage(message.message);
        }
      };

      var resetMessages = function () {
        messaggiSrvc.reset();
      };

      return {
        processaResponse: processaResponse,
        addMessage: addMessage,
        resetMessages: resetMessages
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/messaggiFctr.js
// module id = 7
// module chunks = 0